import { FooterContact, FooterLink, LaravelResponse, getFooter, keyToUrl } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFrontendConfig } from "./config/useFrontendConfig";

const TenantFooter = getFooter();

const queryKey = ["footer-links"];
const fetcher = () => axios.get<LaravelResponse<FooterLink[]>>(keyToUrl(queryKey)).then(({ data }) => data.data);

export const Footer: FC = () => {
	const { company, contactEmail, contactName } = useFrontendConfig();
	const { t } = useTranslation();
	const { data } = useQuery({ queryKey: queryKey, queryFn: fetcher });

	const contact: FooterContact | undefined = useMemo(() => {
		if (!contactEmail || !contactName) {
			return;
		}
		return {
			label: t("Contact"),
			email: contactEmail,
			name: contactName,
		};
	}, [contactEmail, contactName, t]);

	const footerLinks: FooterLink[] = useMemo(() => {
		if (data === undefined) {
			return [];
		}
		return data;
	}, [data]);

	return <TenantFooter company={company} footerLinks={footerLinks} contact={contact} />;
};
